import { useCallback, useState } from "react";
import { usePaginatedRequestCore } from "hooks/usePaginatedRequestCore";
import type { UseLocalPaginatedRequestArgs } from "./types";

export const useLocalPaginatedRequest = <TItem>({
  defaultPage = 1,
  defaultLimit = 20,
  resetDeps,
  service,
}: UseLocalPaginatedRequestArgs<TItem>) => {
  const [page, setPage] = useState(defaultPage);
  const [limit, setLimit] = useState(defaultLimit);

  const handleSetPage = useCallback((nextPage: number) => {
    const safePage = Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1;
    setPage(safePage);
  }, []);

  const handleSetLimit = useCallback(
    (nextLimit: number) => {
      const safeLimit =
        Number.isFinite(nextLimit) && nextLimit > 0 ? nextLimit : defaultLimit;

      setLimit(safeLimit);
      setPage(1); // changing limit resets page
    },
    [defaultLimit]
  );

  const result = usePaginatedRequestCore<TItem>({
    page,
    setPage: handleSetPage,
    limit,
    setLimit: handleSetLimit,
    defaultLimit,
    resetDeps,
    service,
  });

  return result;
};
